import {
  LandingPageThemeId,
  landingPageThemes,
} from '@client/new/common/landingPageThemes';
import { resolvedVisualVersion } from '@client/new/common/landingPageVisualVersion';

export type PageLook = {
  visualVersion: number | null | undefined;
  savedTheme: string | null | undefined;
};

export type PageLookMode = 'staff-note' | 'offer-switch' | 'pick-theme';

const defaultTheme: LandingPageThemeId = 'clean-studio';

export const pageLookMode = (
  isOwnPage: boolean,
  visualVersion: PageLook['visualVersion'],
): PageLookMode => {
  if (!isOwnPage) return 'staff-note';
  return resolvedVisualVersion(visualVersion) === 2
    ? 'pick-theme'
    : 'offer-switch';
};

// A creator moved to version 2 by an AM may have no theme stored; the portal renders those with the default theme.
export const themeOrDefault = (
  savedTheme: PageLook['savedTheme'],
): LandingPageThemeId =>
  landingPageThemes.find((theme) => theme.id === savedTheme)?.id ??
  defaultTheme;

export const themeToSave = (
  look: PageLook,
  selectedTheme: LandingPageThemeId,
): LandingPageThemeId | null =>
  resolvedVisualVersion(look.visualVersion) === 2 &&
  selectedTheme !== themeOrDefault(look.savedTheme)
    ? selectedTheme
    : null;
